<template>
    <!-- Change Default Password Page -->
    <section class="authentication-form py-5">
        <div class="row justify-content-center">
            <div>
                <div class="text-center mb-4">
                    <router-link to="/">
                        <img :src='"../../assets/images/efunding-logo.png"' alt="logo-brand" class="brand-logo mb-3">
                    </router-link>
                    <h3 v-if="!passwordChanged">Ubah Password Default</h3>
                    <p class="text-muted" v-if="!passwordChanged">
                        Demi keamanan akun Anda, ubah password default yang telah dibuat oleh sistem. Pastikan password baru Anda lebih kuat dan mudah diingat.
                    </p>
                </div>

                <!-- Form Section -->
                <div class="card shadow-sm p-4" v-if="!passwordChanged && !isLoading">
                    <form @submit.prevent="handleSubmit">
                        <!-- Input Password Baru -->
                        <div class="form-group position-relative mb-4">
                            <label for="newPassword">Password Baru</label>
                            <div class="position-relative">
                                <input
                                    v-model="newPassword"
                                    :type="showNewPassword ? 'text' : 'password'"
                                    id="newPassword"
                                    class="form-control"
                                    placeholder="Masukkan password baru"
                                />
                                <button
                                    type="button"
                                    class="btn btn-sm btn-outline-secondary position-absolute toggle-password"
                                    @click="toggleShowNewPassword"
                                    :style="{ right: '10px', top: '10px' }"
                                >
                                    <i :class="showNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                                </button>
                            </div>
                        </div>

                        <!-- Input Konfirmasi Password -->
                        <div class="form-group position-relative mb-4">
                            <label for="confirmPassword">Konfirmasi Password Baru</label>
                            <div class="position-relative">
                                <input
                                    v-model="confirmPassword"
                                    :type="showConfirmPassword ? 'text' : 'password'"
                                    id="confirmPassword"
                                    class="form-control"
                                    placeholder="Masukkan kembali password baru"
                                />
                                <button
                                    type="button"
                                    class="btn btn-sm btn-outline-secondary position-absolute toggle-password"
                                    @click="toggleShowConfirmPassword"
                                    :style="{ right: '10px', top: '10px' }"
                                >
                                    <i :class="showConfirmPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                                </button>
                            </div>
                            <p v-if="confirmPasswordMessage" :class="{ 'text-success': confirmPasswordIsValid, 'text-danger': !confirmPasswordIsValid }" class="mt-1">
                                {{ confirmPasswordMessage }}
                            </p>
                        </div>

                        <!-- Submit Button -->
                        <button type="submit" class="btn btn-primary btn-block mt-3">
                            Simpan Password Baru
                        </button>
                    </form>
                </div>

                <!-- Pesan Sukses -->
                <div class="card shadow-sm p-4 text-center" v-else-if="passwordChanged && !isLoading">
                    <h3>Password Berhasil Diubah!</h3>
                    <p class="text-muted">
                        Password Anda telah berhasil diubah. Anda kini dapat menggunakan password baru Anda untuk login ke sistem.
                    </p>
                    <router-link to="/" class="btn btn-success mt-3">Kembali ke Halaman Utama</router-link>
                </div>

                <!-- Spinner -->
                <div class="card shadow-sm p-4 text-center" v-if="isLoading">
                    <b-spinner variant="primary"></b-spinner>
                    <p class="text-muted mt-3">Mengubah password, harap tunggu...</p>
                </div>

                <!-- Pesan Error -->
                <div v-if="errorMessage" class="alert alert-danger text-center mt-3">
                    <p>{{ errorMessage }}</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import User from "../../api/user";

export default {
    data() {
        return {
            newPassword: "",
            confirmPassword: "",
            isLoading: false,
            passwordChanged: false,
            errorMessage: "",
            confirmPasswordMessage: "", // Pesan untuk konfirmasi password
            confirmPasswordIsValid: false, // Status validasi konfirmasi password
            showNewPassword: false, // Kontrol untuk menampilkan/membuka password baru
            showConfirmPassword: false, // Kontrol untuk menampilkan/membuka password konfirmasi
        };
    },
    methods: {
        toggleShowNewPassword() {
            this.showNewPassword = !this.showNewPassword;
        },
        toggleShowConfirmPassword() {
            this.showConfirmPassword = !this.showConfirmPassword;
        },
        validatePassword(password) {
            if (password.length < 8) {
                alert("Password harus memiliki minimal 8 karakter!");
                return false;
            }
            return true;
        },
        validateConfirmPassword() {
            if (this.confirmPassword !== this.newPassword) {
                this.confirmPasswordMessage = "Password konfirmasi tidak cocok.";
                this.confirmPasswordIsValid = false;
                return false;
            }
            this.confirmPasswordMessage = "Password konfirmasi cocok!";
            this.confirmPasswordIsValid = true;
            return true;
        },
        handleSubmit() {
            if (!this.validatePassword(this.newPassword)) {
                return;
            }
            if (!this.validateConfirmPassword()) {
                return;
            }

            this.isLoading = true;
            this.errorMessage = "";

            const user = JSON.parse(localStorage.getItem("user"));
            if (user && user.info && user.info.id) {
                const payload = { new_password: this.newPassword };
                User.changeDefaultPassword(payload)
                    .then((res) => {
                        if (res.data.meta.code === 200) {
                            this.isLoading = false;
                            this.passwordChanged = true;

                            user.info.password_changed = true;
                            localStorage.setItem("user", JSON.stringify(user));
                        } else {
                            this.isLoading = false;
                            this.errorMessage = "Terjadi kesalahan saat mengubah password.";
                        }
                    })
                    .catch((err) => {
                        this.isLoading = false;
                        console.error(err);
                        this.errorMessage = "Terjadi kesalahan saat mengubah password.";
                    });
            } else {
                this.isLoading = false;
                this.errorMessage = "Informasi pengguna tidak valid.";
            }
        },
    },
};
</script>

<style scoped>
.brand-logo {
    max-width: 200px;
}

.authentication-form {
    background-color: #f9f9f9;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}

.card {
    border: none;
    border-radius: 10px;
    background-color: #fff;
}

.toggle-password {
    cursor: pointer;
    padding: 5px;
    background: none;
    border: none;
}

.toggle-password i {
    font-size: 1rem;
    color: #6c757d;
}

.btn-block {
    width: 100%;
}

.text-center {
    text-align: center;
}

.alert {
    border-radius: 10px;
    font-size: 0.9rem;
}

.shadow-sm {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/public/auth/defaultPasswordChange.vue